export default __webpack_public_path__ + "static/media/2022-12-02-twitch-privacy-policy.3a83fb38.md";